import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';

import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-verify',
  templateUrl: './verify.component.html',
  styleUrls: ['../../app.component.scss', './verify.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class VerifyComponent implements OnInit {
  private verifyCode: any;
  private emailCode: string;
  constructor(private _auth: AuthService,
    private _router: Router, private _activeRoute: ActivatedRoute) {
    }

  ngOnInit() {
    const routeParams = this._activeRoute.snapshot.params;

    // Email Verification Code
    this.emailCode = routeParams.email_verify;
    this.verifyCode = {email_code: routeParams.email_verify, purpose: routeParams.purpose};
    this.verifyUserEmail();
  }

  verifyUserEmail() {
    if (this.verifyCode.purpose === 'email') {
      this._auth.verifyEmail(this.verifyCode)
      .subscribe(
        res => {
          this._router.navigate(['/auth/employee/login']);
        },
        error => {
          if (error.status === 0) {
            this._router.navigate(['/auth/employee/login']);
          } else {
            this._router.navigate(['/auth/employee/login']);
          }
        }
      );
    } else if (this.verifyCode.purpose === 'password') {
      this._auth.resetPasswordVerifyEmail(this.verifyCode)
      .subscribe(
        res => {
          if (res.user_id) {
            this._router.navigate(['/auth/reset/password/', this.emailCode, res.user_id]);
          } else {
            this._router.navigate(['/auth/employee/login', res.user_id]);
          }
        },
        error => {
          if (error.status === 0) {
            this._router.navigate(['/auth/employee/login']);
          } else {
            this._router.navigate(['/auth/employee/login']);
          }
        }
      );
    } else {
      this._router.navigate(['/auth/employee/login']);
    }
  }

}
